// auth.service.ts - Version corrigée
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';

import { environment } from '../../../environments/environment';
import { User, AuthResponse } from '../models/auth.models';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<User | null>;
    public currentUser: Observable<User | null>;

    constructor(
        private http: HttpClient,
        private router: Router
    ) {
        this.currentUserSubject = new BehaviorSubject<User | null>(
            JSON.parse(localStorage.getItem('currentUser') || 'null')
        );
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User | null {
        return this.currentUserSubject.value;
    }

    login(numeros: string, password: string) {
        return this.http.post<AuthResponse>(`${environment.apiUrl}/login`, { numeros, password })
            .pipe(
                map(response => {
                    console.log('✅ [Auth Service] Login response:', response);
                    
                    if (response && response.token) {
                        const user: User = {
                            ...response.user,
                            token: response.token,
                            dernier_abonnement: response.dernier_abonnement // IMPORTANT: Ajouter l'abonnement
                        };
                        
                        console.log('✅ [Auth Service] User object created:', user);
                        
                        localStorage.setItem('currentUser', JSON.stringify(user));
                        localStorage.setItem('token', response.token);
                        this.currentUserSubject.next(user);
                        
                        console.log('✅ [Auth Service] Token saved:', response.token.substring(0, 20) + '...');
                    }
                    return response;
                })
            );
    }

    logout() {
        console.log('🚪 [Auth Service] Logout');
        localStorage.removeItem('currentUser');
        localStorage.removeItem('token');
        this.currentUserSubject.next(null);
        this.router.navigate(['/auth/login']);
    }

    isAuthenticated(): boolean {
        const currentUser = this.currentUserValue;
        const isAuth = !!(currentUser && currentUser.token);
        console.log('🔐 [Auth Service] Is Authenticated:', isAuth);
        return isAuth;
    }

    getToken(): string | null {
        const currentUser = this.currentUserValue;
        const token = currentUser?.token || localStorage.getItem('token');
        console.log('🔑 [Auth Service] Get Token:', token ? token.substring(0, 20) + '...' : 'null');
        return token;
    }

    getCurrentUser(): User | null {
        return this.currentUserValue;
    }

    hasValidSubscription(): boolean {
        const user = this.currentUserValue;
        if (!user) return false;
        
        // Vérifier dernier_abonnement
        if (user.dernier_abonnement) {
            const dateFin = new Date(user.dernier_abonnement.dateFin);
            const now = new Date();
            return user.dernier_abonnement.statut && dateFin >= now;
        }
        
        // Fallback sur abonnements (tableau)
        if (user.abonnements && user.abonnements.length > 0) {
            const now = new Date();
            return user.abonnements.some(abonnement => {
                const dateFin = new Date(abonnement.dateFin);
                return abonnement.statut && dateFin >= now;
            });
        }
        
        return false;
    }
}